module.exports = __webpack_public_path__ + "img/logo_assuraf_black_&_white.268d767c.png";